import React, { useState } from 'react';
import { t } from 'i18next';
import { FontWeight, Heading as CommonHeading } from '@lili/lili-frontend-common';
import CopyButton from '../../../generic-components/CopyButton';
import { ReactComponent as CopyIcon } from '../../../assets/icons/svg/shared/ic-shared-duplicate.svg';
import { LiliTooltip, LiliToolTipColor, TooltipPosition } from '../../../DesignSystem/LiliTooltip/LiliTooltip';

const COPY_BUTTON_TIMEOUT = 2000;

interface IProps {
  title: string;
  addressToCopy: string;
}
export const TextWithCopyItem = ({ title, addressToCopy }: IProps) => {
  const [isCopied, setIsCopied] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const buttonId = 'address-copy-button';
  const copyToClipboard = () => {
    if (addressToCopy) {
      navigator.clipboard.writeText(addressToCopy).then(() => {
        setIsCopied(true);
        setTimeout(() => {
          setIsCopied(false);
          setIsFocused(false);
        }, COPY_BUTTON_TIMEOUT);
      });
    }
  };
  //   const copy = t('DIRECT_DEPOSIT_PAGE_COPY');
  const copied = t('DIRECT_DEPOSIT_PAGE_COPIED');

  return (
    <div className='flex  justify-between items-center h-[40px]'>
      <div className='flex w-full flex-col gap-1'>
        <CommonHeading.H10 title={title} fontWeight={FontWeight.SEMIBOLD}>
          {title}
        </CommonHeading.H10>
      </div>
      {isCopied ? (
        <span className='h-[40px] text-bw06 text-xs mt-auto font-metric self-center content-center'>{copied}</span>
      ) : (
        <>
          <CopyButton
            id={buttonId}
            data-tooltip-id={buttonId}
            className={`w-[2.625rem] h-[2.625rem] flex flex-col items-center text-xs font-metric relative  rounded-md  text-action03 ${isFocused && 'bg-bw03'} `}
            title={isCopied ? '' : isFocused ? '' : ''}
            childElement={
              <CopyIcon
                id={`${title}-copy-icon`}
                className={`w-[36px] h-[36px] relative  top-[10px] ${isCopied ? 'text-action03' : 'text-bw06'} `}
              />
            }
            handleOnClick={() => {
              copyToClipboard();
            }}
            handleOnMouseIn={() => {
              setIsFocused(true);
            }}
            handleOnMouseOut={() => {
              setIsFocused(false);
            }}
          />
          <LiliTooltip
            description='sadas'
            targetId={buttonId}
            position={TooltipPosition.BOTTOM}
            color={LiliToolTipColor.Black}
            customContent={<p>Copy</p>}
          />
        </>
      )}
    </div>
  );
};
